<template>
  <v-dialog
    :value="value"
    @input="input"
    width="800"
    persistent
  >
    <SendNotificationForm
      v-model="payload"
      @submit="save"
      @cancel="hide"
      ref="form"
    />
  </v-dialog>
</template>

<script>
import api from '@/api';

const DEFAULT_MESSAGE =
`Sehr geehrter Herr Grossratspräsident/Sehr geehrte Frau Grossratspräsidentin

Sehr geehrte Damen und Herren

Wir haben heute verschiedene Geschäfte für die nächste Grossratssession versandt. Diese Unterlagen sind im Internet aufgeschaltet und können unter folgendem Link eingesehen werden:

https://grinfo.ai.ch/businesses

Freundliche Grüsse
`;

export default {
  name: 'SendNotificationDialog',
  data() {
    return {
      payload: {
        users: [],
        title: '',
        message: DEFAULT_MESSAGE,
      },
    };
  },
  props: {
    value: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    },
    async save() {
      try {
        await api.post('/users/send_notification', {
          title: this.payload.title,
          message: this.payload.message,
          users: this.payload.users.map(user => user.id),
        });
        this.$emit('input', false);
        this.$showSnackbar({
          text: `Benachrichtigung wurde an ${this.payload.users.length} ${this.payload.users.length === 1 ? 'Grossrat' : 'Grossräte'} versendet.`,
          color: 'success'
        });
        Object.assign(this.$data, this.$options.data());
        this.$refs.form.$refs.form.reset();
      } catch (e) {
        this.$showSnackbar({ text: 'Ein unbekannter Fehler ist aufgetreten.', color: 'error' });
        throw e;
      }
    },
    hide() {
      this.$emit('input', false);
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>
